module.exports = __webpack_public_path__ + "static/media/13.f8cb172a.jpeg";